<template>
   <div id="landing">
      <div class="main">
         <div class="header">
            <div class="picture">
               <img src="../../assets/109b036ffc262.jpeg" width="219px" height="256px">
            </div>
            <div class="profile">
               <div class="nametag">
                  <div>Muktar Homam</div>
                  <div class="tagline">CANDIDATE FOR PEO’S WEST-CENTRAL REGIONAL COUNCILLOR</div>
               </div>
               <div class="highlights">
                  · Engineer, lecturer, and manager<br>
                  · Experienced in interprovincial and international engineering practice<br>
                  · Holder of bachelor’s, master’s, and a doctorate in civil engineering<br>
                  · Holder of an MBA, specializing in economics and public management<br>      
                  · Practitioner and business owner<br>
                  · PEO member since 2004<br>
               </div>       
            </div>
         </div>
         <div class="content">
            <h3> PEO Election </h3>
            <div class="sub-section">
               <h4> Message </h4>
               <ul>
                  <a href="https://www.peo.on.ca/sites/default/files/2020-01/Homam-Statement2020.pdf">· Candidate Statement <img src="../../assets/link-icon.png" width="16px" height="12.5px"></a><br>
                  <a href="https://www.peo.on.ca/sites/default/files/2020-01/Homam-AdditionalStatement2020.pdf">· Why am I standing as a Candiate? <img src="../../assets/link-icon.png" width="16px" height="12.5px"></a><br>
                  <a href="https://drive.google.com/file/d/1HAKVUN2-o8WK14Ph-ldTOOVPKIgpCxtR/view?usp=sharing">· What are we voting for? <img src="../../assets/link-icon.png" width="16px" height="12.5px"></a><br>
                  <a href="https://drive.google.com/file/d/1nbscFwEML7ka27rjWjxZPHj5eIHs-kxb/view?usp=sharing">· Why is it very important to vote in 2020? <img src="../../assets/link-icon.png" width="16px" height="12.5px"></a><br>
               </ul>
               <h4> Election Debate </h4>
               <ul>
                  <a href="https://webcast.fmav.ca/PEO2020WCR/index.php?enter">· Election Debate Webcast, Video – Full Debate (40min) <img src="../../assets/link-icon.png" width="16px" height="12.5px"></a><br>
                  <a href="https://drive.google.com/file/d/0BwIm2n0NLjRPUnNzM19FX1J1cldnSU5kZ1A2WElzdlR3Q1ow/view?usp=sharing">· Opening statement, audio – (2min) <img src="../../assets/link-icon.png" width="16px" height="12.5px"></a><br>                  
                  <a href="https://drive.google.com/file/d/0BwIm2n0NLjRPZWRYcVdBa3J6ZmIyQmRTXzlmQ0dtWWd6SXJZ/view?usp=sharing">· Closing statement, audio – (1.5min) <img src="../../assets/link-icon.png" width="16px" height="12.5px"></a><br>
                  <a href="https://drive.google.com/file/d/0BwIm2n0NLjRPRllZQ0dFTVFKZEJibXJKemdsTzVGSXZhYlk0/view?usp=sharing">· Position on chapters, audio – (1.0 min) <img src="../../assets/link-icon.png" width="16px" height="12.5px"></a><br>
                  <a href="https://drive.google.com/file/d/0BwIm2n0NLjRPWHVGWW5jdGxKdVpIWnFGSURRajBnSU15eG5R/view?usp=sharing">· What members need to know, audio – (2.5 min) <img src="../../assets/link-icon.png" width="16px" height="12.5px"></a><br>
               </ul>
            </div>
            <h3> Activities </h3>
            <ul>
               · Nominee – Alumni Member for University of Toronto’s Governing Council<br>
               · Nominee – President, Society of Professional Engineers & Associates<br>
               · Member – Academic Council of Department of Civil Engineering, UofT<br>
               · Chair – Students Committee, Innovative System and Intelligent Structures<br>
               · Mentor – Faculty of Applied Science and Engineering, UofT<br>
            </ul>
            <h3> Professional Experience </h3>
            <ul>
               · Managing Director – Homam Consulting & Business Solutions<br>
               · Senior Structural Engineer – Candu Energy Inc.<br>
               · Senior Structural Engineer – Atomic Energy of Canada Limited<br>
               · Senior Structural Engineer -  SNC Lavalin Nuclear<br>
               · Civil/Structural Engineer – Klohn Crippen Berger Ltd<br>
               · Lecturer/Adjunct – Department of Civil Engineering, UofT<br>
               · Research and Teaching Assistant – Department of Civil Engineering, UofT<br>
               · Visiting Researcher – Ontario Power Generation/Kinectrics<br>
               · Visiting Researcher – National Research Council – Institute for Research in Construction<br>
               · Program Coordinator – Norwegian Afghanistan Committee<br>
            </ul>
            <h3> Articles </h3>
            <ul>
               [1] <a href="http://individual.utoronto.ca/homam/Toronto%20Traffic%20Congestion.pdf">Toronto's Traffic Congestion <img src="../../assets/link-icon.png" width="16px" height="12.5px"></a><br>
               [2] <a href="http://individual.utoronto.ca/homam/unionized_seniority.pdf">Performance-Based Seniority in Unionized Labour Force <img src="../../assets/link-icon.png" width="16px" height="12.5px"></a><br>
               [3] <a href="http://individual.utoronto.ca/homam/21CenturyWorkersStrike.pdf">Strike by Workers of 21st Century <img src="../../assets/link-icon.png" width="16px" height="12.5px"></a><br>
               [4] <a href="http://individual.utoronto.ca/homam/KnoweldgeWorkersSeniority.pdf">Seniority Protection for Unionized Knowledge Workers and its Effects on Worker Motivation and Organizational Efficiency <img src="../../assets/link-icon.png" width="16px" height="12.5px"></a><br>
               [5] <a href="http://individual.utoronto.ca/homam/Labour_Relations_Knowledge_Workers.pdf">Labour Relation and Role of Strike in 21st Century <img src="../../assets/link-icon.png" width="16px" height="12.5px"></a><br>
               [6] <a href="http://individual.utoronto.ca/homam/CPP_benfits.pdf">Pension Plan Benefits Should Be Enhanced, and here is Why <img src="../../assets/link-icon.png" width="16px" height="12.5px"></a><br>
               [7] <a href="http://individual.utoronto.ca/homam/Carbon_tax_versus_cap__trade.pdf">Economic Efficiency of Carbon Tax versus Carbon Cap-and-Trade <img src="../../assets/link-icon.png" width="16px" height="12.5px"></a><br>
               [8] <a href="http://individual.utoronto.ca/homam/Review_Saskatchewan_White_Paper.pdf">A Strong Case for Carbon Tax – Saskatchewan’s Climate Change White Paper <img src="../../assets/link-icon.png" width="16px" height="12.5px"></a><br>
               [9] <a href="http://individual.utoronto.ca/homam/Carbon_Tax_Is_the_Good_Tax_Coming_%20to_%20G7_%20Countries.pdf">Carbon Tax Is the Good Tax and Is Coming to a G7 Country near You <img src="../../assets/link-icon.png" width="16px" height="12.5px"></a><br>
            </ul>
            <h3> Publications </h3>
            * FRP = FIBRE REINFORCED POLYMERS
            <ul>
               · DURABILITY OF FRPs USED IN CONCRETE STRUCTURES - M.A.S.C THESIS (2000)<br>
               · FRPs AND FRP-CONCRETE COMPOSITES SUBJECTED TO VARIOUS LOADS AND ENVIRONMENTAL EXPOSURES - PH.D. THESIS (2005)<br>
               · DURABILITY OF FRPs USED IN CONCRETE STRUCTURES (2000)<br>
               · DURABILITY OF FRP WRAPS AND EXTERNAL FRP-CONCRETE BOND (2001)<br>
               · A DECADE OF PERFORMANCE OF FRP-REPAIRED CONCRETE STRUCTURES (2004)<br>
               · A DECADE OF PERFORMANCE OF FRP-REPAIRED CONCRETE STRUCTURES (2004)<br>
               · DURABILITY OF FRPs EXPOSED TO HIGH TEMPERATURES AND GAMMA RADIATION (2007)<br>
               · LONG-TERM PERFORMANCE MONITORING OF GFRPREPAIRED BRIDGE COLUMNS (2007)<br>
               · DURABLE RETROFITTING OF CONCRETE STRUCTURES (2010)<br>
               · FRPs EXPOSED TO NUCLEAR POWER PLANT ENVIRONMENT (2013)<br>
            </ul>
            <h3> Field and Survey Reports </h3>
            <ul>
               · BASELINE SURVEY OF ZEEBAK, ESHKASHEM AND SEHGHNAN DISTRICTS, BADAKHSHAN, AFGHANISTAN, HOMAM, SAYED MUKHTAR (1994)<br>
            </ul>
            <h3> Other Publications </h3>
            <ul>
               · NORTHERN ONTARIO HYDROELECTRIC DEVELOPMENT POTENTIAL - MINISTRY OF ENERGY, ONTARIO, CANADA (2005)<br>
               · ALBANY RIVER HYDROELECTRIC POTENTIAL - MINISTRY OF ENERGY, ONTARIO, CANADA (2005)<br>
            </ul>
         </div>
      </div>
   </div>      
</template>

<script>
export default {
   name: 'Landing',
   data () {
      return {
         msg: '',
         copyrightYear: (new Date()).getFullYear(),
         investorLabelVisible: true,
         investorContactVisible: false
      }
   },
   computed: {
   },
   methods: {
      preventMouseDown: (e) => {}
   }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

/* + General Page Style */
#landing { 
   height: 100vh;
   overflow-x: hidden;
   overflow-y: auto;
}

/* - General Page Style */

/* + Header Row */
.main {
   max-width: 64rem;
   margin: auto;
}

.header {
   display: flex;
   align-items: center;
   justify-content: center;
   margin-top: 4rem;
}

.tagline {
   font-size: 1rem;
   padding: 1rem 0rem 1rem 0rem;
   font-weight: bold;
}

.picture {
   padding: 4rem;
}

.profile {
   display: grid;
   grid-template-rows: 40% 50%;
   font-size: 1.7rem;
   color: black;
}

.highlights {
   font-size: 1.1rem;
   color: black;
   margin: auto;
}

.highlight-brief {
   font-size: 1rem;
   font-weight: bold;
}

.content {
   width: 66%;
   margin: auto;
}

.sub-section {
   padding-left: 2rem;
}

/* Remove input boxes focus light blue outline */
a:link {
   text-decoration: inherit;
   color: inherit;
   cursor: pointer;
}

a:visited {
   text-decoration: inherit;
   color: inherit;
   cursor: pointer;
}

/* - Header Row */

/* + Responsive UI */
@media screen and (max-width: 960px) {   
   .content {
      width: 84%;
   }
   .profile {
      grid-template-rows: 30% 70%;
   }   
}

@media screen and (max-width: 640px) {
   .profile {
      grid-template-rows: 20% 80%;
      padding: 1rem;
   }
   .picture {
      padding: 1rem;
   }
   .highlights {
      padding: 1rem;
   }
   .content {
      width: 96%;
   }
   .header {
      flex-direction: column;
   }
}
/* - Responsive UI */
</style>



// WEBPACK FOOTER //
// src/components/site/e0.vue